import { Reducer } from 'redux'

import { ReceiptsActionTypes, ReceiptsState } from './types'

const INITIAL_STATE: ReceiptsState = {
  policyViolated: false,
  removeReceiptError: '',
  removeReceiptLoading: false,
  savedReceipt: null,
  saveReceiptError: '',
  saveReceiptLoading: false
}

const reducer: Reducer<ReceiptsState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    /**
     * REMOVE_RECEIPT
     */
    case ReceiptsActionTypes.REMOVE_RECEIPT:
      return {
        ...state,
        removeReceiptError: '',
        removeReceiptLoading: true
      }
    case ReceiptsActionTypes.REMOVE_RECEIPT_SUCCESS:
      return {
        ...state,
        removeReceiptLoading: false
      }
    case ReceiptsActionTypes.REMOVE_RECEIPT_FAILURE:
      return {
        ...state,
        removeReceiptError: payload.message,
        removeReceiptLoading: false
      }

    /**
     * SAVE_RECEIPT
     */
    case ReceiptsActionTypes.SAVE_RECEIPT:
      return {
        ...state,
        savedReceipt: null,
        saveReceiptError: '',
        saveReceiptLoading: true,
        policyViolated: false
      }
    case ReceiptsActionTypes.SAVE_RECEIPT_SUCCESS:
      return {
        ...state,
        saveReceiptLoading: false,
        policyViolated: false
      }
    case ReceiptsActionTypes.SAVE_RECEIPT_FAILURE:
      return {
        ...state,
        saveReceiptError: payload.message,
        saveReceiptLoading: false,
        policyViolated: payload.policyViolated
      }

    /**
     * SET_SAVED_RECEIPT
     */
    case ReceiptsActionTypes.SET_SAVED_RECEIPT:
      return {
        ...state,
        savedReceipt: payload.receipt
      }

    default:
      return state
  }
}

export default reducer
